export const environment = {
  production: true,
  API_ENDPOINT: 'https://inventory.wiktait.com/server/',
  DIRECT_PAGE_ACCESS: 5,
  DASHBOARD_MODULE_GROUP_ID: 7,
  DOCUMENT_UPLOAD_PATH: 'public/uploads/documents/vendor/',
  SALE_UPLOAD_PATH: 'public/uploads/salesUpload/',
  PURCHASE_UPLOAD_PATH: 'public/uploads/purchaseUpload/',
  FLOOD_CESS_PERCENTAGE: 0,
  CURRENCY:'KWD',
}
